import { useTRPC } from "@/trpc/client";
import { useMutation, useQueryClient } from "@tanstack/react-query";

function invalidateAll(qc: ReturnType<typeof useQueryClient>) {
  qc.invalidateQueries({ queryKey: [["salesTeams"]] });
}

export function useCreateSalesTeam() {
  const trpc = useTRPC();
  const qc = useQueryClient();
  return useMutation({
    ...trpc.salesTeams.createTeam.mutationOptions(),
    onSuccess: () => invalidateAll(qc),
  });
}

export function useUpdateSalesTeam() {
  const trpc = useTRPC();
  const qc = useQueryClient();
  return useMutation({
    ...trpc.salesTeams.updateTeam.mutationOptions(),
    onSuccess: () => invalidateAll(qc),
  });
}

export function useDeleteSalesTeam() {
  const trpc = useTRPC();
  const qc = useQueryClient();
  return useMutation({
    ...trpc.salesTeams.deleteTeam.mutationOptions(),
    onSuccess: () => invalidateAll(qc),
  });
}

export function useCreateSalesTeamMember() {
  const trpc = useTRPC();
  const qc = useQueryClient();
  return useMutation({
    ...trpc.salesTeams.createMember.mutationOptions(),
    onSuccess: () => invalidateAll(qc),
  });
}

export function useUpdateSalesTeamMember() {
  const trpc = useTRPC();
  const qc = useQueryClient();
  return useMutation({
    ...trpc.salesTeams.updateMember.mutationOptions(),
    onSuccess: () => invalidateAll(qc),
  });
}

export function useDeleteSalesTeamMember() {
  const trpc = useTRPC();
  const qc = useQueryClient();
  return useMutation({
    ...trpc.salesTeams.deleteMember.mutationOptions(),
    onSuccess: () => invalidateAll(qc),
  });
}

export function useCreateAssessmentSession() {
  const trpc = useTRPC();
  const qc = useQueryClient();
  return useMutation({
    ...trpc.salesTeams.createSession.mutationOptions(),
    onSuccess: () => invalidateAll(qc),
  });
}

export function useAddSessionFile() {
  const trpc = useTRPC();
  const qc = useQueryClient();
  return useMutation({
    ...trpc.salesTeams.addSessionFile.mutationOptions(),
    onSuccess: () => invalidateAll(qc),
  });
}

export function useRemoveSessionFile() {
  const trpc = useTRPC();
  const qc = useQueryClient();
  return useMutation({
    ...trpc.salesTeams.removeSessionFile.mutationOptions(),
    onSuccess: () => invalidateAll(qc),
  });
}

export function useDeleteAssessmentSession() {
  const trpc = useTRPC();
  const qc = useQueryClient();
  return useMutation({
    ...trpc.salesTeams.deleteSession.mutationOptions(),
    onSuccess: () => invalidateAll(qc),
  });
}

export function useSetTeamManager() {
  const trpc = useTRPC();
  const qc = useQueryClient();
  return useMutation({
    ...trpc.salesTeams.setTeamManager.mutationOptions(),
    onSuccess: () => invalidateAll(qc),
  });
}

/**
 * Employee CSV import (GRA-172): teams by name, members upserted by email.
 * Served by the onboarding router because it runs before activation.
 */
export function useImportSalesTeamMembers() {
  const trpc = useTRPC();
  const qc = useQueryClient();
  return useMutation({
    ...trpc.onboarding.importEmployees.mutationOptions(),
    onSuccess: () => {
      invalidateAll(qc);
      qc.invalidateQueries({ queryKey: [["onboarding"]] });
    },
  });
}
